<eventq-dialog-popover
  [open]="open()"
  [title]="title()"
  [cancelLabel]="cancelLabel()"
  [confirmLabel]="confirmLabel()"
  [confirmDisabled]="confirmDisabled()"
  [anchor]="anchor()"
  [placement]="resolvedPlacement()"
  [panelWidth]="panelWidth()"
  (closed)="closed.emit()"
  (confirmed)="onConfirm()"
>
  <div class="disarm-site-popover">
    <div class="disarm-site-popover__timezone">
      <mat-icon class="disarm-site-popover__timezone-icon" aria-hidden="true">info</mat-icon>
      <p class="disarm-site-popover__timezone-text">
        Times set here are local site time zone: {{ resolvedTimezoneLabel() }}
      </p>
    </div>

    <div class="disarm-site-popover__notice" role="status">
      <mat-icon class="disarm-site-popover__notice-icon" aria-hidden="true">info</mat-icon>
      <p class="disarm-site-popover__notice-text">
        Disarming can take up to a minute to reach Schedule Manager. Status may still show as armed until then.
      </p>
    </div>

    <div class="disarm-site-popover__fields">
      <div class="disarm-site-popover__field">
        <span class="disarm-site-popover__label">{{ entityFieldLabel() }}</span>
        <span class="disarm-site-popover__site-name">{{ siteName() }}</span>
      </div>

      <div class="disarm-site-popover__field">
        <span class="disarm-site-popover__label" id="disarm-reason-label">Disarm Reason:</span>
        <eventq-select
          [options]="reasons()"
          [value]="reasonId()"
          placeholder="Select Reason"
          labelledBy="disarm-reason-label"
          [menuPlacement]="reasonMenuPlacement()"
          (valueChange)="onReasonSelect($event)"
        />
      </div>

      <div class="disarm-site-popover__field">
        <span class="disarm-site-popover__label">Disarm For:</span>
        <div class="disarm-site-popover__toggles" role="listbox" aria-label="Disarm For">
          @for (option of disarmForOptions(); track option.id) {
            <button
              type="button"
              class="disarm-site-popover__toggle"
              role="option"
              [class.disarm-site-popover__toggle--selected]="option.id === disarmFor()"
              [attr.aria-selected]="option.id === disarmFor()"
              (click)="onDisarmForSelect(option.id)"
            >
              {{ option.label }}
            </button>
          }
        </div>

        @if (disarmFor() === 'until-next-schedule' && untilNextScheduleWarning()) {
          <div class="disarm-site-popover__warning" role="status">
            <mat-icon class="disarm-site-popover__warning-icon" aria-hidden="true">warning</mat-icon>
            <div class="disarm-site-popover__warning-copy">
              <p class="disarm-site-popover__warning-title">Warning</p>
              <p class="disarm-site-popover__warning-body">{{ untilNextScheduleWarning() }}</p>
            </div>
          </div>
        }

        @if (disarmFor() === 'fixed-time') {
          <div
            class="disarm-site-popover__durations"
            role="listbox"
            aria-label="Fixed time period"
          >
            @for (option of fixedDurationOptions(); track option.minutes) {
              <button
                type="button"
                class="disarm-site-popover__duration"
                role="option"
                [class.disarm-site-popover__duration--selected]="
                  !fixedDurationCustom() && option.minutes === fixedDurationMinutes()
                "
                [attr.aria-selected]="
                  !fixedDurationCustom() && option.minutes === fixedDurationMinutes()
                "
                (click)="onFixedDurationSelect(option.minutes)"
              >
                {{ option.label }}
              </button>
            }
            <button
              type="button"
              class="disarm-site-popover__duration"
              role="option"
              [class.disarm-site-popover__duration--selected]="fixedDurationCustom()"
              [attr.aria-selected]="fixedDurationCustom()"
              (click)="onCustomDurationSelect()"
            >
              Custom
            </button>
          </div>
          @if (fixedDurationCustom()) {
            <label class="disarm-site-popover__custom">
              <span class="disarm-site-popover__custom-label">Minutes</span>
              <input
                class="disarm-site-popover__custom-input"
                type="text"
                inputmode="numeric"
                autocomplete="off"
                aria-label="Custom duration in minutes"
                [value]="fixedDurationCustomDraft()"
                (input)="onCustomDurationInput($event)"
              />
            </label>
          }
        }

        @if (disarmFor() === 'date-time') {
          <div class="disarm-site-popover__datetime">
            <eventq-datetime-picker
              mode="inline"
              [showSeconds]="false"
              [showActions]="false"
              [ianaTimeZone]="ianaTimeZone()"
              [value]="effectiveUntilAtDate()"
              [min]="dateTimeMin()"
              [max]="dateTimeMax()"
              (applied)="onUntilAtApplied($event)"
            />
          </div>
        }
      </div>
    </div>
  </div>
</eventq-dialog-popover>
